import { createAction, props } from '@ngrx/store';
import { ChangelogVersion } from './changelog-versions.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records changelogs version'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records changelogs version success', 
    props<{ listData: ChangelogVersion[] }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records changelogs version failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record changelogs version',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record changelogs version success', 
    props<{ singleData: ChangelogVersion }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record changelogs version failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state faq',
);